import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { ILink, SdButtonComponent } from '@seb/web-design-system/core';

import { AbstractComponent } from '../abstract-component.component';
import { CmsLinkDSComponentInterface } from '../../../models';
import { LinkMapper } from '../../../mappers';

@Component({
  selector: 'wc-cms-link-ds',
  templateUrl: './cms-link-ds.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdButtonComponent]
})
export class CustomCmsLinkDSComponent extends AbstractComponent<CmsLinkDSComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  link: ILink;
  linkName: string;
  target: string;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.subscribe((cmp) => {
        this.link = LinkMapper.cmsLinkToILink(cmp);
        this.linkName = cmp.linkName;
        this.target = this.toTarget(cmp.target);
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  private toTarget(target: string | boolean): string {
    return target === 'true' ? '_blank' : '_self';
  }
}
